import localizeCurrency from "@helpers/localizeCurrency"
import { PaymentIntent } from "@stripe/stripe-js"
import { Trans, useTranslation } from "react-i18next"
import { Plan } from "src/types"

const TERMS_URL = "https://www.calcountai.app/terms"
const PRIVACY_URL = "https://www.calcountai.app/privacy"

interface TermsCheckboxProps {
  fullPrice: number
  isTermsAccepted: boolean
  paymentIntent: PaymentIntent | undefined
  plan: Plan
  setIsTermsAccepted: (isTermsAccepted: boolean) => void
}

export default function TermsCheckbox({
  fullPrice,
  isTermsAccepted,
  paymentIntent,
  plan,
  setIsTermsAccepted,
}: TermsCheckboxProps) {
  const { t } = useTranslation()

  if (!paymentIntent) return null

  return (
    <div className="flex gap-2">
      <input
        checked={isTermsAccepted}
        className="text-custom-teal mt-1 rounded-sm outline-hidden focus:ring-0 focus:ring-offset-0 focus:outline-hidden"
        id="terms-checkbox"
        onChange={(event) => setIsTermsAccepted(event.target.checked)}
        type="checkbox"
      />

      <label
        className="cursor-pointer text-xs leading-relaxed"
        htmlFor="terms-checkbox"
      >
        {paymentIntent &&
          (plan === "weekly"
            ? t("pages.checkout.payment.termsCheckboxLabelWeekly", {
                price: localizeCurrency({
                  amountInCents: fullPrice,
                  currency: paymentIntent.currency,
                }),
              })
            : plan === "monthly"
              ? t("pages.checkout.payment.termsCheckboxLabelMonthly", {
                  price: localizeCurrency({
                    amountInCents: fullPrice,
                    currency: paymentIntent.currency,
                  }),
                })
              : t("pages.checkout.payment.termsCheckboxLabelYearly", {
                  price: localizeCurrency({
                    amountInCents: fullPrice,
                    currency: paymentIntent.currency,
                  }),
                }))}{" "}
        <Trans
          components={{
            termsLink: (
              <a
                className="underline"
                href={TERMS_URL}
                rel="noopener noreferrer"
                target="_blank"
              />
            ),
            privacyLink: (
              <a
                className="underline"
                href={PRIVACY_URL}
                rel="noopener noreferrer"
                target="_blank"
              />
            ),
          }}
          i18nKey="pages.checkout.payment.termsLegal"
        />
      </label>
    </div>
  )
}
